"use strict";

const IExecModule = require('./IExecModule');

const {
  checkWeb2SecretExists
} = require('../common/sms/check');

const {
  pushWeb2Secret
} = require('../common/sms/push');

const {
  getResultEncryptionKeyName
} = require('../common/utils/secrets-utils');

class IExecResultModule extends IExecModule {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    this.checkResultEncryptionKeyExists = async address => checkWeb2SecretExists(await this.config.resolveContractsClient(), await this.config.resolveSmsURL(), address, getResultEncryptionKeyName());

    this.pushResultEncryptionKey = async function (publicKey) {
      let {
        forceUpdate = false
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return pushWeb2Secret(await _this.config.resolveContractsClient(), await _this.config.resolveSmsURL(), getResultEncryptionKeyName(), publicKey, {
        forceUpdate
      });
    };
  }

}

module.exports = IExecResultModule;